import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import MainBanner from "../components/Home/mainBanner";
import MainList from "../components/Home/mainList";
import MainNoticePopup from "../components/Home/MainNoticePopup";
import { apiGet } from "../utils/api";

export default function Home() {

  // const navigate = useNavigate();

  const [bannerPayload, setBannerPayload] = useState(null);
  const [homePayload, setHomePayload] = useState(null);

  // Load the banner and home payload in parallel on first render.
  useEffect(() => {
    let isActive = true;

    const fetchHomePagePayloads = async () => {
      const bannerPromise = apiGet("/main/get_home_banner_payload.php");
      const homePromise = apiGet("/main/get_home_payload.php", {
        include_main_cruise_list: 0,
        include_tab_products: 0,
      });

      bannerPromise
        .then((bannerData) => {
          if (!isActive) return;
          if (bannerData?.success) {
            setBannerPayload(bannerData.data || null);
          }
        })
        .catch((error) => {
          if (!isActive) return;
          console.error("메인 배너 로딩 실패:", error);
        });

      homePromise
        .then((homeData) => {
          if (!isActive) return;
          if (homeData?.success) {
            setHomePayload(homeData.data || null);
          }
        })
        .catch((error) => {
          if (!isActive) return;
          console.error("메인 데이터 로딩 실패:", error);
        });
    };

    fetchHomePagePayloads();

    return () => {
      isActive = false;
    };
  }, []);

  // // 검색 실행
  // const handleSearch = (formValues) => {
  //   const mapToApiParams = {
  //     destination: "r",
  //     departure: "d",
  //     port: "v",
  //     startdate: "m", // 문자열 '6월' → 숫자 6으로 변환 필요
  //     spreadnights: "n",
  //     lineid: "l"
  //   };

  //   const params = {};

  //   Object.entries(formValues).forEach(([key, value]) => {
  //     if (value !== "") {
  //       const apiKey = mapToApiParams[key];
  //       if (apiKey) {
  //         /** 
  //          * 250818(제갈민혁) - 검색시 월 replace 수정
  //         */
  //         // if (key === "startdate" && value.endsWith("월")) {
  //         //   params[apiKey] = parseInt(value.replace("월", ""), 10);
  //         // } 
  //         if (key === "startdate") {
  //           let monthValue = value;
  //           if (typeof monthValue === 'string' && monthValue.endsWith("월")) {
  //               monthValue = parseInt(monthValue.replace("월", ""), 10);
  //           }
  //           params[apiKey] = monthValue;
  //         } else {
  //           params[apiKey] = value;
  //         }
  //       }
  //     }
  //   });

  //   const query = new URLSearchParams(params).toString();
  //   navigate(`/search?${query}`);
  // };


  return (
    <>
      <MainNoticePopup />
      <MainBanner
        bannerData={bannerPayload?.main_banner ?? null}
        promoData={bannerPayload?.promo_banners ?? null}
        promoItemsData={bannerPayload?.promo_banner_items ?? null}
        cruiseInfoData={bannerPayload?.cruise_info_banners ?? null}
        cruiseInfoItemsData={bannerPayload?.cruise_info_banner_items ?? null}
      />
      {/* 651px 이하에서는 숨김 */}
      {/* {isWide && (
        <SearchGroup moTitle='조건에 맞는 크루즈 검색 하기'/>
      )} */}
      {/* 프로모션 배너 */}
      {/* <PromotionBanner /> */}
      <MainList
        cruiseLines={homePayload?.main_cruise_lines ?? null}
        homeReviews={homePayload ? (homePayload?.main_reviews ?? []) : undefined}
      />
    </>
  );
}
